import { render, staticRenderFns } from "./EmbedUserDrafts.vue?vue&type=template&id=aeac4c66&"
import script from "./EmbedUserDrafts.vue?vue&type=script&lang=js&"
export * from "./EmbedUserDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports